<template>
  <div class="good" v-on:click="ViewDetail">
    <van-image fit="fill" height="150px" :src="imgUrl"></van-image>
    <div class="goodName">{{goodName}}</div>
    <div class="price">￥{{price}}</div>
  </div>
</template>

<script>
export default {
  name: "goodGird",
  props: {
    imgUrl: String,
    id: Number,
    price: String,
    goodName: String,
  },
  methods: {
    ViewDetail() {
      this.$router.push({
        name: "GoodDetail",
        params: { id: this.id },
      });
      console.log(this.id);
    },
  },
};
</script>

<style>
.good {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  /* height: 150px; */
  max-width: 150px;
  /* height: 175px; */
}
.goodName {
  /* padding: 10px; */
  font-size: 13px;

  text-overflow: ellipsis;
  overflow: hidden;
  /* width: 90%; */
  /* max-width: 40%; */
  text-align: center;
  white-space: nowrap;
  color: #3e3e3e;
  margin-top: 5px;
  text-align: center;
}
.price {
  color: #fb3939;
  font-size: 15px;
}
</style>